<template>
    <div>
        <b-row class="mb-2">
            <b-col md="6">
                <h5 v-if="notification.type === 'OWNER'">Owner Notification</h5>
                <h5 v-if="notification.type === 'SUBMITTER'">Submitter Notification</h5>
            </b-col>
            <b-col md="6" class="text-right" v-if="isAdmin">
                <b-form-checkbox :id="notification.type + '-notification-active'"
                                 :name="notification.type + '-notification-active'"
                                 class="ckc-switch-square" switch
                                 v-model="notification.active">
                    Active
                </b-form-checkbox>
            </b-col>
        </b-row>
        <b-form-row>
            <b-col md="4">
                <b-form-group label="From Address" label-for="notification-fromAddress" class="required">
                    <b-form-input :id="notification.type + '-notification-fromAddress'"
                                  :name="notification.type + '-notification-fromAddress'"
                                  v-model="notification.fromAddress" required/>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label="From Alias"
                              label-for="notification-fromAlias" class="required">
                    <b-form-input :id="notification.type + '-notification-fromAlias'"
                                  :name="notification.type + '-notification-fromAlias'"
                                  v-model="notification.fromAlias" required/>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label="Subject" label-for="notification-subject" class="required">
                    <b-form-input :id="notification.type + '-notification-subject'"
                                  :name="notification.type + '-notification-subject'" v-model="notification.subject" required/>
                </b-form-group>
            </b-col>
        </b-form-row>

        <b-form-group label="Template" label-for="notification-htmlContent" class="required">
            <Trumbowyg :id="notification.type + '-notification-htmlContent'"
                       :name="notification.type + '-notification-htmlContent'" v-model="notification.htmlContent"
                       :config="trumbowygConfig" required></Trumbowyg>
        </b-form-group>
    </div>
</template>

<script>
    import EditorUtils from "@/services/utils/EditorUtils";
    import Trumbowyg from 'vue-trumbowyg';
    import 'trumbowyg/dist/ui/trumbowyg.css';

    export default {
        name: "PortalNotification",
        mixins: [EditorUtils],
        components: {
            Trumbowyg
        },
        props: {
            notification: Object
        },
        computed: {
            isAdmin() {
                return this.$store.getters.isAdmin;
            }
        },
    }
</script>

<style scoped>

</style>